import Vue from 'vue'
// import Vuetify from 'vuetify/lib'
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'

Vue.use(Vuetify)
